import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  date: {
    startDate: "",
    endDate: "",
  },
};
const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {
    setDate: (state, action) => {
      const payload = action.payload;
      state.date = {
        ...state.date,
        ...payload,
      };
    },
    clearDate: (state) => {
      state.date = {
        startDate: "",
        endDate: "",
      };
    },
  },
});
export const { setDate, clearDate } = dateSlice.actions;
export default dateSlice.reducer;
